import React from 'react';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const VaccineAppointments = () => {
  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Vaccine Appointments</h1>
        <p className="mt-2 text-sm text-gray-600">
          This page is available in the router, but the scheduling GraphQL module has not been implemented in Nova.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Backend Status</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 text-sm text-gray-700">
          <p>The previous UI referenced `getVaccineAppointments`, `getVaccineTimeTables`, and related mutations.</p>
          <p>Those operations and input types do not exist in the current executable schema, so this page now stays read-only until the backend is built.</p>
          <p>When the Nova vaccine scheduling module is added, this page can be reconnected to the real operations instead of carrying stale GraphQL documents.</p>
        </CardContent>
      </Card>
    </div>
  );
};
